import { createContext } from 'react';

const ModalContext = createContext({});

export const { Consumer, Provider } = ModalContext;

export default ModalContext;
